import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavItem } from '../data/nav-item.model';
import { LoginNavigator } from '../../migration/shared/login.navigator';

@Injectable({ providedIn: 'root' })
export class PortalNavService {
  constructor(
    private router: Router,
    private readonly loginNavigator: LoginNavigator
  ) {}
  go(item: NavItem): void {
    if (item.external) {
      window.open(item.external, '_blank', 'noopener');
      return;
    }
    localStorage.removeItem('formulario');
    if (item.action === 'logout') {
      // Borra todo el storage como siempre; LoginNavigator además reinicia el estado en memoria
      // (PortalStore, selección del paso 7) y navega a /auth/login, porque la app no se recarga.
      localStorage.clear();
      this.loginNavigator.go();
      return;
    }
    if (item.route) this.router.navigate([item.route]);
  }
  /**
   * Activo si la ruta del item matchea la URL actual (exacta o por segmento completo) Y ningún
   * OTRO item del mismo grupo tiene una ruta más específica (más larga) que también matchee —
   * evita que dos items con rutas anidadas (ej. /portal/cupos y /portal/cupos/informacion) se
   * resalten a la vez.
   */
  isActive(item: NavItem, siblings: NavItem[] = []): boolean {
    if (!item.route) return false;
    const url = this.router.url;
    const matches = (route: string) => url === route || url.startsWith(route + '/');
    if (!matches(item.route)) return false;
    return !siblings.some(
      (other) => other !== item && !!other.route && other.route.length > item.route!.length && matches(other.route)
    );
  }
}
